import script from "./SupportedBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportedBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./SupportedBrowser.vue?vue&type=style&index=0&id=728761a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728761a1"]])

export default __exports__